import { DocumentTypes } from '@core/constants/document-types';
import { Profiles } from '@core/constants/profiles';
import { Routes } from '@core/constants/routes';

interface LayoutState {
  title: string;
  subtitle: string;
  backLink?: [Routes];
  stretch?: boolean;
}

export interface Personal {
  id: string | number;
  name: string;
  email: string;
  email_supervisor: string;
  role: `${Profiles}`;
  document: string;
  document_type?: DocumentTypes;
  address?: string;
  reward?: Array<{name: string, units: number}>;
  goals?: Array<{type: string, quantity: number, activity_id: number}>;
  mobile?: string;
  phone?: number | string;
  isNew?: boolean | number;
  validateCheckIn?: boolean;
  latitude?: number;
  longitude?: number;
  [key: string]: any;
}

export interface Actions {
  setLayoutContent: (content: Partial<LayoutState>) => void;
  setCampaignId: (campaignId: number) => void;
  setPersonalInfo: (personal: Personal[]) => void;
  setPersonId: (id?: string) => void;
  setNewPerson: (person: Personal) => void;
  editPerson: (data: Personal) => void;
  deletePerson: (id: string) => void;
  reset: () => void;
}

interface State {
  layout: LayoutState;
  personal: Personal[];
  campaign?: number;
  personId?: string;
  computed: {
    selectedPerson?: Personal;
  };
}

export type PersonalStore = State & Actions;

export const initialState: State = {
  layout: {
    title: 'Gestionar personal',
    subtitle:
      'Agrega los supervisores y personal de punto de venta para la campaña',
    backLink: [Routes.CAMPAINGS],
  },
  personal: [],
  computed: {},
};
